import styled from 'styled-components';
import {dFlex, alignCenter, dFlexColumn, justifyBetween, alignStart} from '../../globalVariables/GlobalFlex';
import {LIGHT_BLUE_GRAY, OLIVE_GREEN, TURQUISE_BLUE, BLACK, GRAY3, SHADOW_COLOR, LIGHT_GRAY5} from '../../globalVariables/GlobalVariables';
import {blackSuccess} from '../../assets/symbols/symbols/Symbols.css';
import {maskImage, BGImageCenter} from '../../globalVariables/GlobalVariables';

export const packageCard = styled.div`
    ${dFlexColumn};
    ${alignStart};
    padding: 16px;
    border: 1px solid ${LIGHT_GRAY5};
    border-radius: 8px;
    background: white;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
    gap: 5px;
    &:hover {
        border-color: ${OLIVE_GREEN};
        box-shadow: ${SHADOW_COLOR};
    }
    
    &.selected {
        border-color: ${OLIVE_GREEN};
        background: ${LIGHT_BLUE_GRAY};
        border-color: ${TURQUISE_BLUE};
    }
`;

export const packageCardTitle = styled.div`
    ${dFlex};
    ${alignCenter};
    ${justifyBetween};
    gap: 12px;
    font-size: 14px;
    width: 100%;
`;

export const packagePrice = styled.div`
    font-weight: 700;
    color: ${BLACK};
`;

export const packageName = styled.div`
    font-weight: 600;
    color: ${BLACK};
    position: relative;
    padding-inline-start: 35px;
    &::before {
        content: '';
        position: absolute;
        inset-inline-start: 0px;
        inset-block-start: 0;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 2px solid ${OLIVE_GREEN};
        transition: all 0.2s;
        ${BGImageCenter(blackSuccess, '8px 6px')}
    }
    &.selected::before {
        background-color: ${OLIVE_GREEN};
    }
`;

export const detailItem = styled.div<{$icon: string}>`
    ${dFlex};
    gap: 6px;
    font-size: 14px;
    color: ${BLACK};
    position: relative;
    padding-inline-start: 55px;
    &::before{
        content: '';
        position: absolute;
        inset-inline-start: 35px;
        inset-block-start: 0;
        width: 16px;
        height: 16px;
        ${p=>maskImage(p.$icon, GRAY3, 'contain')}
    }
`;
